import React from 'react';
import { LockIcon } from 'lucide-react';
import { Section, Eyebrow } from './Section';
import { LinkButton } from './Button';
import { Reveal } from './Reveal';
interface ClosingCTAProps {
  eyebrow?: string;
  title?: string;
  body?: string;
}
export function ClosingCTA({
  eyebrow = 'Start the conversation',
  title = 'A first conversation costs nothing but an hour.',
  body = 'We will talk through your family’s situation, tell you plainly whether we are the right fit, and put nothing in front of you to buy.'
}: ClosingCTAProps) {
  return <Section tone="charcoal" ariaLabel="Book a consultation" data-id="element-25" data-mp="3fv9i2gllwsar">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-26" data-mp="3163nj5xprq97">
        <Eyebrow tone="cream" data-id="element-27" data-mp="36685l0e9st1j">{eyebrow}</Eyebrow>
        <h2 className="mt-4 font-serif text-h2 text-cream" data-id="element-28" data-mp="364x271oqlnay">{title}</h2>
        <p className="mx-auto mt-5 max-w-xl text-[1.0625rem] leading-relaxed text-cream/70" data-id="element-29" data-mp="3tvala2pcgbte">{body}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-30" data-mp="2hodjitr4eus">
          <LinkButton to="/contact" size="lg" data-id="element-31" data-mp="w3ipdwgyxwr6">
            Book a consultation
          </LinkButton>
          <LinkButton to="/locations" variant="outline" size="lg" className="border-cream/25 text-cream hover:border-cream/60 hover:bg-cream/[0.06]" data-id="element-32" data-mp="r57j1vpvu4dp">
            Find your local adviser
          </LinkButton>
        </div>
        <p className="mt-7 flex items-center justify-center gap-2 text-xs text-cream/45" data-id="element-33" data-mp="1eu9xyvt4tj4i">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="1ew384l2yelh9" />
          Everything you share stays between you and your adviser.
        </p>
      </Reveal>
    </Section>;
}